import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import QuestionsApp from "apps/questions";
import "./Questions.scss";

const Questions = (props) => {
	const { isWide } = props;

	const questionClasses = classnames({
		"discovery-promo-questions": true,
		isWide,
	});

	return (
		<div className={questionClasses}>
			<div className="discovery-promo-questions-title">
				Improve your matches
			</div>
			<QuestionsApp binaryQuestionsMode />
		</div>
	);
};

Questions.propTypes = {
	isWide: PropTypes.bool,
};

export default Questions;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/interruptions/Questions.jsx